// extracted by mini-css-extract-plugin
module.exports = {"svgSprite":"_1cBaD","svgIcon":"_2Lx80"};